import { CSSProperties, ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface TrProps {
  borders?: boolean;
  children?: ReactNode;
}

interface ThProps {
  lines?: number;
  style?: CSSProperties;
  children?: ReactNode;
}

export const Tr = styled.div<TrProps>`
  background: ${({ theme }) => theme.palette.neutral.main};
  padding: 0 25px;
  min-height: 64px;
  vertical-align: middle;

  ${({ borders }) =>
    borders &&
    css`
      border-bottom: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};
    `}
`;

export const Th = styled.div<ThProps>`
  border-bottom: none;
  font:
    400 16px 'Open Sans',
    sans-serif;
  letter-spacing: 0.02em;
  padding: ${({ lines }) => (lines == 2 ? 12 : 25)}px 15px;
  white-space: nowrap;
  display: inline-block;
  text-align: left;
  vertical-align: top;

  ${({ style }) =>
    style &&
    css`
      flex: ${`${style.width} 0 auto`};
    `}
`;

interface WrapperProps {
  children?: ReactNode;
}

export const Wrapper = styled.div<WrapperProps>`
  position: absolute;
  bottom: 0;
  width: 100%;
`;
